import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@mui/material";
import RewardBanner from "../../Analysis/Assets/RewardBannerNew.png";
import CustomizedSteppers from "../components/Progress";

const useStyles = makeStyles((theme) => ({
  imgBig: {
    width: "75%",
    padding: "1%",
  },
}));

const Banner = ({ data }) => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={12} md={12} sm={12} style={{ textAlign: "center" }}>
        <img src={RewardBanner} className={classes.imgBig} />
      </Grid>
      <Grid item xs={12} md={12} sm={12}>
        <CustomizedSteppers data={data} />
      </Grid>
    </Grid>
  );
};

export default Banner;
